const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL || 'https://login.testing.keyholding.com'
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'keyholding'
const CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'poc-web'

export const authority = `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`
export const clientId = CLIENT_ID
